// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.script.runtime.ObjectValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.IgnitorSlotLike
import io.peekandpoke.klang.script.stdlib.KatalystSlotLike
import io.peekandpoke.klang.sprudel.SprudelPattern
import io.peekandpoke.klang.sprudel.lang.PatternLike
import io.peekandpoke.klang.sprudel.lang.PatternMapperFn
import io.peekandpoke.klang.sprudel.lang.PatternMapperProvider
import io.peekandpoke.klang.sprudel.lang.abs
import io.peekandpoke.klang.sprudel.lang.accelerate
import io.peekandpoke.klang.sprudel.lang.add
import io.peekandpoke.klang.sprudel.lang.adsr
import io.peekandpoke.klang.sprudel.lang.adsrCurves
import io.peekandpoke.klang.sprudel.lang.adsrOff
import io.peekandpoke.klang.sprudel.lang.adsrOn
import io.peekandpoke.klang.sprudel.lang.almostAlways
import io.peekandpoke.klang.sprudel.lang.almostNever
import io.peekandpoke.klang.sprudel.lang.always
import io.peekandpoke.klang.sprudel.lang.analog
import io.peekandpoke.klang.sprudel.lang.and
import io.peekandpoke.klang.sprudel.lang.apply
import io.peekandpoke.klang.sprudel.lang.applyN
import io.peekandpoke.klang.sprudel.lang.arrange
import io.peekandpoke.klang.sprudel.lang.bandpass
import io.peekandpoke.klang.sprudel.lang.bank
import io.peekandpoke.klang.sprudel.lang.beatRate
import io.peekandpoke.klang.sprudel.lang.beats
import io.peekandpoke.klang.sprudel.lang.begin
import io.peekandpoke.klang.sprudel.lang.berlin
import io.peekandpoke.klang.sprudel.lang.binary
import io.peekandpoke.klang.sprudel.lang.binaryL
import io.peekandpoke.klang.sprudel.lang.binaryN
import io.peekandpoke.klang.sprudel.lang.binaryNL
import io.peekandpoke.klang.sprudel.lang.bitAnd
import io.peekandpoke.klang.sprudel.lang.bitOr
import io.peekandpoke.klang.sprudel.lang.bitShl
import io.peekandpoke.klang.sprudel.lang.bitShr
import io.peekandpoke.klang.sprudel.lang.bitXor
import io.peekandpoke.klang.sprudel.lang.bite
import io.peekandpoke.klang.sprudel.lang.bjork
import io.peekandpoke.klang.sprudel.lang.body
import io.peekandpoke.klang.sprudel.lang.bpf
import io.peekandpoke.klang.sprudel.lang.bpfCurves
import io.peekandpoke.klang.sprudel.lang.bpm
import io.peekandpoke.klang.sprudel.lang.brak
import io.peekandpoke.klang.sprudel.lang.brand
import io.peekandpoke.klang.sprudel.lang.brandBy
import io.peekandpoke.klang.sprudel.lang.bypass
import io.peekandpoke.klang.sprudel.lang.cat
import io.peekandpoke.klang.sprudel.lang.ceil
import io.peekandpoke.klang.sprudel.lang.choose
import io.peekandpoke.klang.sprudel.lang.chooseCycles
import io.peekandpoke.klang.sprudel.lang.chooseIn
import io.peekandpoke.klang.sprudel.lang.chooseInWith
import io.peekandpoke.klang.sprudel.lang.chooseOut
import io.peekandpoke.klang.sprudel.lang.chooseWith
import io.peekandpoke.klang.sprudel.lang.chord
import io.peekandpoke.klang.sprudel.lang.chunk
import io.peekandpoke.klang.sprudel.lang.chunkBack
import io.peekandpoke.klang.sprudel.lang.chunkBackInto
import io.peekandpoke.klang.sprudel.lang.chunkInto
import io.peekandpoke.klang.sprudel.lang.chunkback
import io.peekandpoke.klang.sprudel.lang.chunkbackinto
import io.peekandpoke.klang.sprudel.lang.chunkinto
import io.peekandpoke.klang.sprudel.lang.clamp
import io.peekandpoke.klang.sprudel.lang.clip
import io.peekandpoke.klang.sprudel.lang.coarse
import io.peekandpoke.klang.sprudel.lang.comp
import io.peekandpoke.klang.sprudel.lang.compress
import io.peekandpoke.klang.sprudel.lang.compressor
import io.peekandpoke.klang.sprudel.lang.cosine
import io.peekandpoke.klang.sprudel.lang.cps
import io.peekandpoke.klang.sprudel.lang.crush
import io.peekandpoke.klang.sprudel.lang.cull
import io.peekandpoke.klang.sprudel.lang.cut
import io.peekandpoke.klang.sprudel.lang.cylinder
import io.peekandpoke.klang.sprudel.lang.d
import io.peekandpoke.klang.sprudel.lang.degrade
import io.peekandpoke.klang.sprudel.lang.degradeBy
import io.peekandpoke.klang.sprudel.lang.degradeByWith
import io.peekandpoke.klang.sprudel.lang.delay
import io.peekandpoke.klang.sprudel.lang.density
import io.peekandpoke.klang.sprudel.lang.densityGap
import io.peekandpoke.klang.sprudel.lang.distort
import io.peekandpoke.klang.sprudel.lang.div
import io.peekandpoke.klang.sprudel.lang.drop
import io.peekandpoke.klang.sprudel.lang.duck
import io.peekandpoke.klang.sprudel.lang.duty
import io.peekandpoke.klang.sprudel.lang.early
import io.peekandpoke.klang.sprudel.lang.earlyInCycle
import io.peekandpoke.klang.sprudel.lang.echo
import io.peekandpoke.klang.sprudel.lang.echoWith
import io.peekandpoke.klang.sprudel.lang.echowith
import io.peekandpoke.klang.sprudel.lang.eish
import io.peekandpoke.klang.sprudel.lang.end
import io.peekandpoke.klang.sprudel.lang.eq
import io.peekandpoke.klang.sprudel.lang.eqt
import io.peekandpoke.klang.sprudel.lang.euclid
import io.peekandpoke.klang.sprudel.lang.euclidLegato
import io.peekandpoke.klang.sprudel.lang.euclidLegatoRot
import io.peekandpoke.klang.sprudel.lang.euclidRot
import io.peekandpoke.klang.sprudel.lang.euclidish
import io.peekandpoke.klang.sprudel.lang.euclidrot
import io.peekandpoke.klang.sprudel.lang.every
import io.peekandpoke.klang.sprudel.lang.extend
import io.peekandpoke.klang.sprudel.lang.fast
import io.peekandpoke.klang.sprudel.lang.fastChunk
import io.peekandpoke.klang.sprudel.lang.fastGap
import io.peekandpoke.klang.sprudel.lang.fastcat
import io.peekandpoke.klang.sprudel.lang.fastchunk
import io.peekandpoke.klang.sprudel.lang.filterWhen
import io.peekandpoke.klang.sprudel.lang.firstOf
import io.peekandpoke.klang.sprudel.lang.flipSign
import io.peekandpoke.klang.sprudel.lang.floor
import io.peekandpoke.klang.sprudel.lang.fm
import io.peekandpoke.klang.sprudel.lang.focus
import io.peekandpoke.klang.sprudel.lang.freq
import io.peekandpoke.klang.sprudel.lang.gain
import io.peekandpoke.klang.sprudel.lang.gap
import io.peekandpoke.klang.sprudel.lang.gt
import io.peekandpoke.klang.sprudel.lang.gte
import io.peekandpoke.klang.sprudel.lang.highpass
import io.peekandpoke.klang.sprudel.lang.hpf
import io.peekandpoke.klang.sprudel.lang.hpfCurves
import io.peekandpoke.klang.sprudel.lang.hurry
import io.peekandpoke.klang.sprudel.lang.hush
import io.peekandpoke.klang.sprudel.lang.ignitorParam
import io.peekandpoke.klang.sprudel.lang.ignp
import io.peekandpoke.klang.sprudel.lang.inhabit
import io.peekandpoke.klang.sprudel.lang.inhabitmod
import io.peekandpoke.klang.sprudel.lang.inside
import io.peekandpoke.klang.sprudel.lang.inv
import io.peekandpoke.klang.sprudel.lang.invert
import io.peekandpoke.klang.sprudel.lang.irand
import io.peekandpoke.klang.sprudel.lang.iter
import io.peekandpoke.klang.sprudel.lang.iterBack
import io.peekandpoke.klang.sprudel.lang.jux
import io.peekandpoke.klang.sprudel.lang.juxBy
import io.peekandpoke.klang.sprudel.lang.katalyst
import io.peekandpoke.klang.sprudel.lang.katalystParam
import io.peekandpoke.klang.sprudel.lang.katp
import io.peekandpoke.klang.sprudel.lang.lastOf
import io.peekandpoke.klang.sprudel.lang.late
import io.peekandpoke.klang.sprudel.lang.lateInCycle
import io.peekandpoke.klang.sprudel.lang.layer
import io.peekandpoke.klang.sprudel.lang.legato
import io.peekandpoke.klang.sprudel.lang.linger
import io.peekandpoke.klang.sprudel.lang.log2
import io.peekandpoke.klang.sprudel.lang.loop
import io.peekandpoke.klang.sprudel.lang.loopAt
import io.peekandpoke.klang.sprudel.lang.loopAtCps
import io.peekandpoke.klang.sprudel.lang.loopatcps
import io.peekandpoke.klang.sprudel.lang.lowpass
import io.peekandpoke.klang.sprudel.lang.lpf
import io.peekandpoke.klang.sprudel.lang.lpfCurves
import io.peekandpoke.klang.sprudel.lang.lt
import io.peekandpoke.klang.sprudel.lang.lte
import io.peekandpoke.klang.sprudel.lang.mask
import io.peekandpoke.klang.sprudel.lang.maskAll
import io.peekandpoke.klang.sprudel.lang.master
import io.peekandpoke.klang.sprudel.lang.max
import io.peekandpoke.klang.sprudel.lang.merge
import io.peekandpoke.klang.sprudel.lang.min
import io.peekandpoke.klang.sprudel.lang.mini
import io.peekandpoke.klang.sprudel.lang.mod
import io.peekandpoke.klang.sprudel.lang.morse
import io.peekandpoke.klang.sprudel.lang.mul
import io.peekandpoke.klang.sprudel.lang.mute
import io.peekandpoke.klang.sprudel.lang.n
import io.peekandpoke.klang.sprudel.lang.ne
import io.peekandpoke.klang.sprudel.lang.net
import io.peekandpoke.klang.sprudel.lang.never
import io.peekandpoke.klang.sprudel.lang.noCull
import io.peekandpoke.klang.sprudel.lang.not
import io.peekandpoke.klang.sprudel.lang.notch
import io.peekandpoke.klang.sprudel.lang.notchCurves
import io.peekandpoke.klang.sprudel.lang.note
import io.peekandpoke.klang.sprudel.lang.nothing
import io.peekandpoke.klang.sprudel.lang.o
import io.peekandpoke.klang.sprudel.lang.off
import io.peekandpoke.klang.sprudel.lang.often
import io.peekandpoke.klang.sprudel.lang.oneMinusValue
import io.peekandpoke.klang.sprudel.lang.onepole
import io.peekandpoke.klang.sprudel.lang.or
import io.peekandpoke.klang.sprudel.lang.orbit
import io.peekandpoke.klang.sprudel.lang.outside
import io.peekandpoke.klang.sprudel.lang.pace
import io.peekandpoke.klang.sprudel.lang.palindrome
import io.peekandpoke.klang.sprudel.lang.pan
import io.peekandpoke.klang.sprudel.lang.penv
import io.peekandpoke.klang.sprudel.lang.penvCurves
import io.peekandpoke.klang.sprudel.lang.perlin
import io.peekandpoke.klang.sprudel.lang.phaser
import io.peekandpoke.klang.sprudel.lang.pick
import io.peekandpoke.klang.sprudel.lang.pickF
import io.peekandpoke.klang.sprudel.lang.pickOut
import io.peekandpoke.klang.sprudel.lang.pickReset
import io.peekandpoke.klang.sprudel.lang.pickRestart
import io.peekandpoke.klang.sprudel.lang.pickSqueeze
import io.peekandpoke.klang.sprudel.lang.pickmod
import io.peekandpoke.klang.sprudel.lang.pickmodF
import io.peekandpoke.klang.sprudel.lang.pickmodOut
import io.peekandpoke.klang.sprudel.lang.pickmodReset
import io.peekandpoke.klang.sprudel.lang.pickmodRestart
import io.peekandpoke.klang.sprudel.lang.pickmodSqueeze
import io.peekandpoke.klang.sprudel.lang.ply
import io.peekandpoke.klang.sprudel.lang.plyForEach
import io.peekandpoke.klang.sprudel.lang.plyWith
import io.peekandpoke.klang.sprudel.lang.plyforeach
import io.peekandpoke.klang.sprudel.lang.plywith
import io.peekandpoke.klang.sprudel.lang.polymeter
import io.peekandpoke.klang.sprudel.lang.polymeterSteps
import io.peekandpoke.klang.sprudel.lang.polyrhythm
import io.peekandpoke.klang.sprudel.lang.pow
import io.peekandpoke.klang.sprudel.lang.pregain
import io.peekandpoke.klang.sprudel.lang.press
import io.peekandpoke.klang.sprudel.lang.pressBy
import io.peekandpoke.klang.sprudel.lang.pure
import io.peekandpoke.klang.sprudel.lang.rand
import io.peekandpoke.klang.sprudel.lang.randCycle
import io.peekandpoke.klang.sprudel.lang.randcat
import io.peekandpoke.klang.sprudel.lang.randrun
import io.peekandpoke.klang.sprudel.lang.range
import io.peekandpoke.klang.sprudel.lang.rangex
import io.peekandpoke.klang.sprudel.lang.rarely
import io.peekandpoke.klang.sprudel.lang.ratio
import io.peekandpoke.klang.sprudel.lang.repeat
import io.peekandpoke.klang.sprudel.lang.repeatCycles
import io.peekandpoke.klang.sprudel.lang.rest
import io.peekandpoke.klang.sprudel.lang.rev
import io.peekandpoke.klang.sprudel.lang.reverb
import io.peekandpoke.klang.sprudel.lang.revv
import io.peekandpoke.klang.sprudel.lang.rib
import io.peekandpoke.klang.sprudel.lang.ribbon
import io.peekandpoke.klang.sprudel.lang.rootNotes
import io.peekandpoke.klang.sprudel.lang.round
import io.peekandpoke.klang.sprudel.lang.rpm
import io.peekandpoke.klang.sprudel.lang.run
import io.peekandpoke.klang.sprudel.lang.s
import io.peekandpoke.klang.sprudel.lang.s_cat
import io.peekandpoke.klang.sprudel.lang.saw
import io.peekandpoke.klang.sprudel.lang.scale
import io.peekandpoke.klang.sprudel.lang.scaleTranspose
import io.peekandpoke.klang.sprudel.lang.scramble
import io.peekandpoke.klang.sprudel.lang.seed
import io.peekandpoke.klang.sprudel.lang.seg
import io.peekandpoke.klang.sprudel.lang.segment
import io.peekandpoke.klang.sprudel.lang.seq
import io.peekandpoke.klang.sprudel.lang.sequenceP
import io.peekandpoke.klang.sprudel.lang.shuffle
import io.peekandpoke.klang.sprudel.lang.signal
import io.peekandpoke.klang.sprudel.lang.silence
import io.peekandpoke.klang.sprudel.lang.sine
import io.peekandpoke.klang.sprudel.lang.sineOfDay
import io.peekandpoke.klang.sprudel.lang.sineOfNight
import io.peekandpoke.klang.sprudel.lang.slice
import io.peekandpoke.klang.sprudel.lang.slow
import io.peekandpoke.klang.sprudel.lang.slowChunk
import io.peekandpoke.klang.sprudel.lang.slowcat
import io.peekandpoke.klang.sprudel.lang.slowcatPrime
import io.peekandpoke.klang.sprudel.lang.slowchunk
import io.peekandpoke.klang.sprudel.lang.sndBrown
import io.peekandpoke.klang.sprudel.lang.sndCrackle
import io.peekandpoke.klang.sprudel.lang.sndDust
import io.peekandpoke.klang.sprudel.lang.sndNoise
import io.peekandpoke.klang.sprudel.lang.sndPink
import io.peekandpoke.klang.sprudel.lang.sndPluck
import io.peekandpoke.klang.sprudel.lang.sndPulze
import io.peekandpoke.klang.sprudel.lang.sndRamp
import io.peekandpoke.klang.sprudel.lang.sndSaw
import io.peekandpoke.klang.sprudel.lang.sndSine
import io.peekandpoke.klang.sprudel.lang.sndSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperPluck
import io.peekandpoke.klang.sprudel.lang.sndSuperRamp
import io.peekandpoke.klang.sprudel.lang.sndSuperSaw
import io.peekandpoke.klang.sprudel.lang.sndSuperSine
import io.peekandpoke.klang.sprudel.lang.sndSuperSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperTri
import io.peekandpoke.klang.sprudel.lang.sndTri
import io.peekandpoke.klang.sprudel.lang.sndZamp
import io.peekandpoke.klang.sprudel.lang.solo
import io.peekandpoke.klang.sprudel.lang.someCycles
import io.peekandpoke.klang.sprudel.lang.someCyclesBy
import io.peekandpoke.klang.sprudel.lang.sometimes
import io.peekandpoke.klang.sprudel.lang.sometimesBy
import io.peekandpoke.klang.sprudel.lang.sound
import io.peekandpoke.klang.sprudel.lang.speed
import io.peekandpoke.klang.sprudel.lang.splice
import io.peekandpoke.klang.sprudel.lang.square
import io.peekandpoke.klang.sprudel.lang.squeeze
import io.peekandpoke.klang.sprudel.lang.stack
import io.peekandpoke.klang.sprudel.lang.stackBy
import io.peekandpoke.klang.sprudel.lang.stackCentre
import io.peekandpoke.klang.sprudel.lang.stackLeft
import io.peekandpoke.klang.sprudel.lang.stackRight
import io.peekandpoke.klang.sprudel.lang.steady
import io.peekandpoke.klang.sprudel.lang.stepcat
import io.peekandpoke.klang.sprudel.lang.steps
import io.peekandpoke.klang.sprudel.lang.stretchBy
import io.peekandpoke.klang.sprudel.lang.struct
import io.peekandpoke.klang.sprudel.lang.structAll
import io.peekandpoke.klang.sprudel.lang.stut
import io.peekandpoke.klang.sprudel.lang.stutWith
import io.peekandpoke.klang.sprudel.lang.stutwith
import io.peekandpoke.klang.sprudel.lang.sub
import io.peekandpoke.klang.sprudel.lang.superimpose
import io.peekandpoke.klang.sprudel.lang.swing
import io.peekandpoke.klang.sprudel.lang.swingBy
import io.peekandpoke.klang.sprudel.lang.tag
import io.peekandpoke.klang.sprudel.lang.take
import io.peekandpoke.klang.sprudel.lang.time
import io.peekandpoke.klang.sprudel.lang.timeCat
import io.peekandpoke.klang.sprudel.lang.timeLoop
import io.peekandpoke.klang.sprudel.lang.timeOfDay
import io.peekandpoke.klang.sprudel.lang.timeOfNight
import io.peekandpoke.klang.sprudel.lang.timecat
import io.peekandpoke.klang.sprudel.lang.transpose
import io.peekandpoke.klang.sprudel.lang.tremolo
import io.peekandpoke.klang.sprudel.lang.tri
import io.peekandpoke.klang.sprudel.lang.tweak
import io.peekandpoke.klang.sprudel.lang.tweaks
import io.peekandpoke.klang.sprudel.lang.undegrade
import io.peekandpoke.klang.sprudel.lang.undegradeBy
import io.peekandpoke.klang.sprudel.lang.undegradeByWith
import io.peekandpoke.klang.sprudel.lang.uni
import io.peekandpoke.klang.sprudel.lang.unison
import io.peekandpoke.klang.sprudel.lang.unit
import io.peekandpoke.klang.sprudel.lang.vel
import io.peekandpoke.klang.sprudel.lang.velocity
import io.peekandpoke.klang.sprudel.lang.vib
import io.peekandpoke.klang.sprudel.lang.vibrato
import io.peekandpoke.klang.sprudel.lang.voicing
import io.peekandpoke.klang.sprudel.lang.vowel
import io.peekandpoke.klang.sprudel.lang.wchoose
import io.peekandpoke.klang.sprudel.lang.wchooseCycles
import io.peekandpoke.klang.sprudel.lang.`when`
import io.peekandpoke.klang.sprudel.lang.withSeed
import io.peekandpoke.klang.sprudel.lang.within
import io.peekandpoke.klang.sprudel.lang.wrandcat
import io.peekandpoke.klang.sprudel.lang.zoom
import kotlin.Function1

internal fun KlangScriptExtensionBuilder.registerSprudelLangFiltersChunk0() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "bpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "bpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "bpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("bpf") on bpf
    registerObject("bpf", bpf) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "bpf", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                bpf.invoke(
                    freq = optArg(args, 0, Any::class, loc),
                    q = optArg(args, 1, Any::class, loc),
                    env = optArg(args, 2, Any::class, loc),
                    attack = optArg(args, 3, Any::class, loc),
                    decay = optArg(args, 4, Any::class, loc),
                    sustain = optArg(args, 5, Any::class, loc),
                    release = optArg(args, 6, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
        registerProperty("freq") { bpf.freq }
        registerProperty("q") { bpf.q }
        registerProperty("env") { bpf.env }
        registerProperty("attack") { bpf.attack }
        registerProperty("decay") { bpf.decay }
        registerProperty("sustain") { bpf.sustain }
        registerProperty("release") { bpf.release }
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "bandpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bandpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bandpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "bandpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bandpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bandpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Property on bandpass
    registerObject("bandpass", bandpass)

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "bandpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bandpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bandpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "bpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "bpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("bpfCurves") on bpfCurves
    registerObject("bpfCurves", bpfCurves) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "bpfCurves", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                bpfCurves.invoke(
                    attack = optArg(args, 0, Any::class, loc),
                    decay = optArg(args, 1, Any::class, loc),
                    release = optArg(args, 2, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "bpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.bpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangFiltersChunk1() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "hpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "hpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.hpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "hpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "hpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.hpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "hpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "hpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.hpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("hpf") on hpf
    registerObject("hpf", hpf) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "hpf", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                hpf.invoke(
                    freq = optArg(args, 0, Any::class, loc),
                    q = optArg(args, 1, Any::class, loc),
                    passes = optArg(args, 2, Any::class, loc),
                    env = optArg(args, 3, Any::class, loc),
                    attack = optArg(args, 4, Any::class, loc),
                    decay = optArg(args, 5, Any::class, loc),
                    sustain = optArg(args, 6, Any::class, loc),
                    release = optArg(args, 7, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
        registerProperty("freq") { hpf.freq }
        registerProperty("q") { hpf.q }
        registerProperty("passes") { hpf.passes }
        registerProperty("env") { hpf.env }
        registerProperty("attack") { hpf.attack }
        registerProperty("decay") { hpf.decay }
        registerProperty("sustain") { hpf.sustain }
        registerProperty("release") { hpf.release }
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "highpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "highpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.highpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "highpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "highpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.highpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Property on highpass
    registerObject("highpass", highpass)

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "highpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "highpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.highpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "hpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "hpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.hpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "hpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "hpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.hpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("hpfCurves") on hpfCurves
    registerObject("hpfCurves", hpfCurves) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "hpfCurves", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                hpfCurves.invoke(
                    attack = optArg(args, 0, Any::class, loc),
                    decay = optArg(args, 1, Any::class, loc),
                    release = optArg(args, 2, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "hpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "hpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.hpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangFiltersChunk2() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "lpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "lpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "lpf",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lpf", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lpf(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("lpf") on lpf
    registerObject("lpf", lpf) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "lpf", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                lpf.invoke(
                    freq = optArg(args, 0, Any::class, loc),
                    q = optArg(args, 1, Any::class, loc),
                    passes = optArg(args, 2, Any::class, loc),
                    env = optArg(args, 3, Any::class, loc),
                    attack = optArg(args, 4, Any::class, loc),
                    decay = optArg(args, 5, Any::class, loc),
                    sustain = optArg(args, 6, Any::class, loc),
                    release = optArg(args, 7, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
        registerProperty("freq") { lpf.freq }
        registerProperty("q") { lpf.q }
        registerProperty("passes") { lpf.passes }
        registerProperty("env") { lpf.env }
        registerProperty("attack") { lpf.attack }
        registerProperty("decay") { lpf.decay }
        registerProperty("sustain") { lpf.sustain }
        registerProperty("release") { lpf.release }
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "lowpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lowpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lowpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "lowpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lowpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lowpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Property on lowpass
    registerObject("lowpass", lowpass)

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "lowpass",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "passes", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lowpass", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lowpass(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                passes = optArg(args, 2, Any::class, loc),
                env = optArg(args, 3, Any::class, loc),
                attack = optArg(args, 4, Any::class, loc),
                decay = optArg(args, 5, Any::class, loc),
                sustain = optArg(args, 6, Any::class, loc),
                release = optArg(args, 7, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "lpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "lpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("lpfCurves") on lpfCurves
    registerObject("lpfCurves", lpfCurves) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "lpfCurves", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                lpfCurves.invoke(
                    attack = optArg(args, 0, Any::class, loc),
                    decay = optArg(args, 1, Any::class, loc),
                    release = optArg(args, 2, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "lpfCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "lpfCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.lpfCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangFiltersChunk3() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "notch",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "notch", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.notch(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "notch",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "notch", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.notch(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "notch",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "notch", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.notch(
                freq = optArg(args, 0, Any::class, loc),
                q = optArg(args, 1, Any::class, loc),
                env = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                decay = optArg(args, 4, Any::class, loc),
                sustain = optArg(args, 5, Any::class, loc),
                release = optArg(args, 6, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("notch") on notch
    registerObject("notch", notch) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "q", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "env", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "notch", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                notch.invoke(
                    freq = optArg(args, 0, Any::class, loc),
                    q = optArg(args, 1, Any::class, loc),
                    env = optArg(args, 2, Any::class, loc),
                    attack = optArg(args, 3, Any::class, loc),
                    decay = optArg(args, 4, Any::class, loc),
                    sustain = optArg(args, 5, Any::class, loc),
                    release = optArg(args, 6, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
        registerProperty("freq") { notch.freq }
        registerProperty("q") { notch.q }
        registerProperty("env") { notch.env }
        registerProperty("attack") { notch.attack }
        registerProperty("decay") { notch.decay }
        registerProperty("sustain") { notch.sustain }
        registerProperty("release") { notch.release }
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "notchCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "notchCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.notchCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "notchCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "notchCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.notchCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("notchCurves") on notchCurves
    registerObject("notchCurves", notchCurves) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "notchCurves", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                notchCurves.invoke(
                    attack = optArg(args, 0, Any::class, loc),
                    decay = optArg(args, 1, Any::class, loc),
                    release = optArg(args, 2, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "notchCurves",
        paramSpecs = listOf(
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "notchCurves", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.notchCurves(
                attack = optArg(args, 0, Any::class, loc),
                decay = optArg(args, 1, Any::class, loc),
                release = optArg(args, 2, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

